/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAwsCustomLensChoice {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAwsCustomLensChoice.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAwsCustomLensChoice>): WellArchitectedFrameworkAwsCustomLensChoice {
        let obj = Object.assign(new WellArchitectedFrameworkAwsCustomLensChoice(), model);
        WellArchitectedFrameworkAwsCustomLensChoice.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAwsCustomLensChoice>): WellArchitectedFrameworkAwsCustomLensChoice {
        if (!model) return null;
        return WellArchitectedFrameworkAwsCustomLensChoice.newInstance(<WellArchitectedFrameworkAwsCustomLensChoice> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAwsCustomLensChoice) {
        if (!obj) return;

        models.WellArchitectedFrameworkAwsCustomLensChoice.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAwsCustomLensChoice): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAwsCustomLensChoice.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.helpful_resource) {
            models.WellArchitectedFrameworkAwsCustomLensRecommendation.fixupPrototype(this.helpful_resource);
        }
        if (this.improvement_plan) {
            models.WellArchitectedFrameworkAwsCustomLensRecommendation.fixupPrototype(this.improvement_plan);
        }
    }

    /**
     * Id of choice of AWS custom lens
     */
    sys_id: string;

    /**
     * Title of choice of AWS custom lens
     */
    title: string;

    /**
     * Helpful resources associated with AWS custom lens
     */
    helpful_resource: models.WellArchitectedFrameworkAwsCustomLensRecommendation;

    /**
     * Improvement plans associated with AWS custom lens
     */
    improvement_plan: models.WellArchitectedFrameworkAwsCustomLensRecommendation;

}
